// removed by extract-text-webpack-plugin
module.exports = {"horizontal":"_1GvDy3nQFNbEicidKhNhh1","vertical":"_2_QL1VWqJHdSuLKe6oAM3J"};


//////////////////
// WEBPACK FOOTER
// ../~/react-toolbox/lib/navigation/theme.scss
// module id = 541
// module chunks = 0